<!--订购按钮  -->
<template>
    <div :style="{ width:width,height:height,lineHeight:height}" class="change-item-left-b" @click="handleClick">
        立即订购
    </div>
</template>

<script>
export default {
    name: "orderBtn",
    props: {
        width: {
            type: String,
        },
        height: {
            type: String,
        }
    },
    data() {
        return {
        }
    },
    mounted() { },
    methods: {
      handleClick() {
        this.$emit('click')
      }
    }
};
</script>

<style lang="less" scoped>
.change-item-left-b {
    width: 140px;
    height: 36px;
    background: #629812;
    box-shadow: 0px 2px 6px 0px rgba(81, 136, 0, 0.3);
    border-radius: 36px;
    font-size: 16px;
    font-family: PingFangHK-Medium, PingFangHK;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
}

.change-item-left-b:hover {
    background: rgba(107, 174, 7, 0.994);
    color: #efefef;
}
</style>



// WEBPACK FOOTER //
// src/components/components/orderBtn.vue